import React,{useState,useEffect} from 'react'
function Detail() {


  let genreids={
    28:'Action', 12:'Adventure',16:'Animation',35:'Comedy',80:'Crime',99:'Documentary',18:'Drama',10751:'Family',
    14:'Fantasy',36:'History',27:'Horror',10402:'Music',9648:'Mystery',10749:'Romance',878:'Sci-Fi',10778:'Tv',
    53:'Thriller',10752:'War',37:'Western'
  }

  let [detail,setdetail]=useState([])
  let [movies,setMovies]=useState([])
  
useEffect(function () {
    
   let olddet=localStorage.getItem("singleMovie");
          olddet=JSON.parse(olddet) 
          console.log(olddet);
          setdetail(olddet)

    },
    []
  )

  return (
    <div className='bg-yellow-200 '>
     { detail.map((movie)=>( 
        <><div div className='flex justify-center'> 
         <div className={`bg-[url(https://image.tmdb.org/t/p/original/${movie.backdrop_path})]
     h-[25vh] md:h-[45vh] 
    object-fit
     bg-contain mt-8 
    w-[90vw] md:w-[37vw]
    flex justify-center
    `}>

      <div className='flex justify-center text-2xl ext-3xl md:text-5xl font-semibold items-end py-5 text-white opacity-70
     w-[100vw]
      
      '>{movie.title}</div>
       </div> 
       </div>
       <div className='flex m-6 justify-center'>
           <div className='mx-2 bg-gray-700 text-white p-2 font-bold rounded-xl'> {genreids[movie.genre_ids[0]]}</div>
           <div className='mx-2 bg-gray-700 text-white p-2 font-bold rounded-xl'> {genreids[movie.genre_ids[1]]}</div>
          
           <div className='mx-2 bg-gray-700 text-white p-2 font-bold rounded-xl'> {genreids[movie.genre_ids[2]]}</div>
           
         </div>
         <div className='flex justify-center'>
         <div className='flex justify-center bg-gray-700
          text-white font-bold p-2 rounded-xl md:w-[9vw]'>
            ⭐Rating : {movie.vote_average}
            </div>

         </div>
         <div className='m-4 flex justify-center font-bold '>
         <div className='mb-80 flex justify-center md:w-[47vw] md:h-[30vh] text-white bg-gray-700 rounded-xl p-2'>Overview: &nbsp;{movie.overview}</div>
         </div>
         </>
     ))}
    </div>
  )
}

export default Detail
